module.exports = __webpack_public_path__ + "static/img/location.cfc266ea.svg";